import { useEffect, useRef } from 'react';
import { Flex, Scroll } from 'components';
import './style.scss';

interface IProps {
  year: number;
  onAccept: (year: number) => void;
}

function StageYear(props: IProps) {
  const minYear = props.year - 120;
  const maxYear = props.year + 120;

  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current != null) {
      const heihtOffset = (scrollRef.current as any).offsetHeight / 4;
      (scrollRef.current as any).scrollTop = (scrollRef.current as any).scrollHeight / 2 - heihtOffset;
    }
  }, [scrollRef.current]);

  return (
    <Flex
      direction='column'
      className='stage-Z9Ru'
      gap={10}
    >
      <Scroll ref={scrollRef}>
        <Flex
          direction='column'
          gap={5}
        >
          {[...Array(maxYear - minYear)].map((_, i) => (
            <Year
              onClick={() => props.onAccept(minYear + i)}
              year={minYear + i}
              key={i}
              selected={props.year === minYear + i}
            />
          ))}
        </Flex>
      </Scroll>
    </Flex>
  );
}

interface IYearProps {
  year: number;
  selected: boolean;
  onClick: () => void;
}

function Year(props: IYearProps) {
  let className = 'year-xGwv';

  if (props.selected) {
    className += ' sel-ylXd';
  }

  return (
    <Flex
      justifyContent='center'
      className={className}
      onClick={props.onClick}
    >
      <div>{props.year}</div>
    </Flex>
  );
}
export default StageYear;
